export default __webpack_public_path__ + "static/media/odznaka-5.3e069a19.svg";